<template>
  <div>
        <h2>GU (IE)</h2>
    <v-container v-if="!loading" class="py-10">
        <v-row>
            <v-col v-for="item in guie" class="shrink my-0 py-0" cols="12" md="4" :key="item.id">
                <v-checkbox
                        v-model="guieCheckbox"
                        :disabled="disableGuie(item.id, item.is_normal)"
                        :label='item.name'
                        :value="item.id"
                        hide-details
                        @change="toggle => guieTick(item.id, toggle, item.is_normal)"
                />
            </v-col>
        </v-row>
        <v-row v-if="isGuieRemark">
            <v-col>
                <v-text-field
                        placeholder="Other"
                        outlined
                        v-model="guie_remark"
                        :rules="[v => !!v || 'Guie Other is required']"
                        label="Guie Other"
                        @keyup="includeGuieRemark"
                        required
                />
            </v-col>
        </v-row>
    </v-container>
    <v-container v-else style="text-align: center;">
      <v-progress-circular
        :size="150"
        color="primary"
        indeterminate
        style="text-align: center"
      >Loading Data
      </v-progress-circular>
    </v-container>
  </div>
</template>

<script>
    export default {
        name: "Guie",

        props: {
            formData: {
                type: Object,
                required: true,
            },
            config: Number
        },

        data() {
            return {
                isGuieRemark: false,
                guie_remark: null,
                isGuieNormal: false,
                guie: {},
                guieCheckbox: [],
                loading: true,
            }
        },

        methods: {
            editFieldGuie() {
                let vm = this;
                _.forEach(this.formData.physical_examination.guie, function(value) {
                    vm.guieCheckbox.push(Number.parseInt(value.guie_id));
                    if (value.guie_remark) {
                        vm.guie_remark = value.guie_remark;
                        vm.isGuieRemark = true;
                    }
                });
            },

            disableGuie(id, normal = 0, toggle = true) {
                let vm = this;
                _.forEach(this.formData.physical_examination.guie, function (value) {
                    if (Number.parseInt(value.guie_id) === Number.parseInt(id) && normal && toggle) {
                        vm.isGuieNormal = true;
                    }
                });
                return this.guieCheckbox.indexOf(id) === -1 && this.isGuieNormal;
            },

            guieTick(key, toggle, is_normal) {
                let toggled = toggle.includes(key);
                let guie = this.formData.physical_examination.guie;

                if (key === this.config) {
                    this.isGuieRemark = !this.isGuieRemark;
                }
                if (is_normal) {
                    this.isGuieNormal = !this.isGuieNormal;
                    this.guieNormalOnly(key, toggled);
                    this.disableGuie(key, is_normal, toggled);
                }

                if (toggled) {
                    guie.push({
                        guie_id: key,
                        guie_remark: null,
                    });
                } else {
                    let index = guie.findIndex(guie => guie.guie_id === key);
                    guie.splice(index, 1);
                }
            },

            guieNormalOnly(key, toggled) {
                if (toggled){
                    let guie = this.formData.physical_examination.guie;
                    guie.push({
                        guie_id: key,
                        guie_remark: null,
                    });
                    this.guieCheckbox = [key];
                    guie.splice(0, guie.length);
                    this.isGuieRemark = false;
                }
            },

            includeGuieRemark() {
                let guie = this.formData.physical_examination.guie;
                let index = guie.findIndex(guie => guie.guie_id === this.config);
                guie.splice(index, 1);
                guie.push({
                    guie_id: this.config,
                    guie_remark: this.guie_remark,
                });
            },

            getGuieLib() {
                this.axios.get('guie-lib', {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                    }
                }).then((response) => {
                    // handle success
                    this.guie = response.data;
                    this.loading = false;
                }).catch((error) => {
                    // handle error
                    console.error(error);
                }).finally(() => {
                    // always executed
                });
            },
        },

        mounted() {
            this.getGuieLib();
            this.editFieldGuie();
        }
    }
</script>

<style scoped>

</style>